module.exports = __webpack_public_path__ + "static/media/browsers.afeca4d9.svg";